import { render, staticRenderFns } from "./HomeMaintenancePackages.vue?vue&type=template&id=04b9fcca&scoped=true"
import script from "./HomeMaintenancePackages.vue?vue&type=script&lang=js"
export * from "./HomeMaintenancePackages.vue?vue&type=script&lang=js"
import style0 from "./HomeMaintenancePackages.vue?vue&type=style&index=0&id=04b9fcca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b9fcca",
  null
  
)

export default component.exports